<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // 获取当前宿主
    const userAgent = navigator.userAgent;
    const userAgentLower = userAgent.toLowerCase();
    if (userAgent.indexOf('AliApp') > -1){
      this.$store.commit("setSource",'alipay');
    }else if(userAgentLower.match(/micromessenger/i) == "micromessenger"){
      this.$store.commit("setSource",'wechat');
    }else if(userAgent.indexOf("OpenHarmony") > -1){
      this.$store.commit("setSource",'harmony');
    }else{
      this.$store.commit("setSource",'app');
    }
  },
};


</script>

<style>
html,
body,
#app {
  height: 100%;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

* {
  padding: 0;
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

.vc-switch {
  height: 50px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/* .slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  position: absolute;
} */

/* .slide-right-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
} */

.van-toast {
  z-index: 99999 !important;
}
</style>
